module.exports = __webpack_public_path__ + "static/media/Avatar1.232fd216.png";